import Api from "services/axios_instance";
import { IResponse } from "types/common";
import {
  TripPayment_Request,
  GetTripDetail_Request,
  GetTripDetail_Response,
  GetApplicationSettings_Response,
  GetApplicationRules_Response,
} from "./types";

const tripPaymentUrl: string = process.env.REACT_APP_TRIP_PAYMENT!;

//Passenger Rules
const getApplicationSettingsUrl: string =
  process.env.REACT_APP_GET_APPLICATION_SETTINGS!;
const getApplicationRulesUrl: string =
  process.env.REACT_APP_GET_APPLICATION_RULES!;
//Trip-Detail
const getTripDetailUrl: string = process.env.REACT_APP_GET_TRIP_DETAIL!;

const PassengerServices = {
  async GetApplicationSettings() {
    const response = await Api(true).get<
      IResponse<GetApplicationSettings_Response>
    >(getApplicationSettingsUrl);
    return response.data;
  },

  async GetApplicationRules() {
    const response = await Api(true).get<
      IResponse<GetApplicationRules_Response>
    >(getApplicationRulesUrl);
    return response.data;
  },

  async GetTripDetail(request: GetTripDetail_Request) {
    const response = await Api().get<IResponse<GetTripDetail_Response>>(
      getTripDetailUrl,
      {
        params: {
          id: request.id,
          platformType: request.platformType,
        },
      }
    );
    return response.data;
  },

  async TripPayment(request: TripPayment_Request) {
    const response = await Api().post<IResponse<null>>(tripPaymentUrl, request);
    return response.data;
  },
};

export default PassengerServices;
